export { default } from './PartnersSlider';
